
import UnsaveGuardMixin from '@/components/UnsaveGuardMixin';
import { Component, Ref, Watch, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { v4 } from 'uuid';
import SelectVideoModal from './SelectVideoModal.vue';
import SelectImagesModal from './SelectImagesModal.vue';
import LookImagesModal from './LookImagesModal.vue';
import QualityDescriptionModal from './QualityDescriptionModal.vue';
import CoverImagesModal from './CoverImagesModal.vue';
import VideoUModal from '@/components/video/VideoModal.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import LookVideoModal from './LookVideoModal.vue';
import DelVideoModal from './DelVideoModal.vue';
import { AuthEnum } from '@/services/permission.service';

@Component({
  components: {
    draggable,
    SelectVideoModal,
    SelectImagesModal,
    LookImagesModal,
    QualityDescriptionModal,
    CoverImagesModal,
    VideoUModal,
    LookVideoModal,
    DelVideoModal,
  },
})
export default class AlbumManagement extends UnsaveGuardMixin {
  uuid = v4;

  formData: any = {};

  doorFaceImage: any = [];

  oldFaceId: any = [];

  formFactory: any = {
    addFace: [],
    delFace: [],
  };

  AuthEnum = AuthEnum;

  @Ref('videoUModal')
  videoUModal!: VideoUModal;

  @Ref('delVideoModal')
  delVideoModal!: DelVideoModal;

  @lazyInject(ShopService)
  shopService!: ShopService;

  // albumData: any = {};

  @Ref('selectVideoModal')
  selectVideoModal!: SelectVideoModal;

  @Ref('selectImagesModal')
  selectImagesModal!: SelectImagesModal;

  @Ref('lookImagesModal')
  lookImagesModal!: LookImagesModal;

  @Ref('qualityDescriptionModal')
  qualityDescriptionModal!: QualityDescriptionModal;

  @Ref('coverImagesModal')
  coverImagesModal!: CoverImagesModal;

  @Ref('lookVideoModal')
  lookVideoModal!: LookVideoModal;

  @Prop()
  albumData?: any;

  @Prop()
  shopId?: any;

  @Prop()
  isKaShop?: any;

  disabled = true;

  headerList = [];
  headrtBList: any = [];

  headerVideo: any = [];

  sourceType = '';


  headerImg: any = [0, 0, 0, 0, 0];

  defaultDate: any = [];


  wordTitleArray: any = [
    { title: '环境', id: '', type: 'env' },
    { title: '产品服务', id: '', type: 'product_service' },
    { title: '其他', id: '', type: 'other' },
    { title: '店内环境', id: '', type: 'inner_env' },
  ];

  @Watch('headerList', { deep: true })
  onHeaderListChange() {
    // console.log(this.headerList);
  }

  clearExceptions() {
    // console.log('清除异常', this.headerImg);
    // const newArr = this.headerImg.map((item: any) => {
    //   return item.resource_id;
    // });
    // console.log(newArr);
    this.delVideoModal.init();
  }

  setStorefront(data: any, type: any) {
    // console.log('setStorefront', data, type);
    if (!type) {
      if (this.doorFaceImage.length > 2) {
        this.$message.error('最多只能设置3张');
        return;
      }
      this.doorFaceImage.push(data);
      this.formFactory.addFace.push(data);
      this.formFactory.delFace = this.formFactory.delFace.filter((item: any) => item !== data);
    } else {
      this.doorFaceImage = this.doorFaceImage.filter((item: any) => item !== data);
      this.formFactory.delFace.push(data);
    }

    this.formFactory.addFace = this.formFactory.addFace.filter((item: any) => this.doorFaceImage.includes(item) && !this.oldFaceId.includes(item));
    this.formFactory.delFace = this.formFactory.delFace.filter((item: any) => this.oldFaceId.includes(item));
    // console.log(this.formFactory, 'formFactory');
    // console.log(this.oldFaceId, 'oldFaceId');
  }

  upload() {
    this.$emit('refResg');
  }
  deepArraysEqual(a: any[], b: any[]): boolean {
    const cleanedA = a.filter((item) => item != null);
    const cleanedB = b.filter((item) => item != null);
    return JSON.stringify(cleanedA) === JSON.stringify(cleanedB);
  }

  draftCount(type: any) {
    const res = this.formData[type];
    if (res) {
      return res.add.length;
    } else {
      return 0;
    }
  }

  async submit() {
    const header: any = [...[this.headerVideo], ...this.headrtBList, ...this.headerImg];
    const data: any = Object.assign({}, this.formData, {
      shopId: this.shopId,
      header: header.filter((item: any) => item !== 0 && item !== undefined && item.resource_id != null).map((item: any) => item.resource_id),
    });
    if (this.deepArraysEqual(data.header, this.oldHeaderId)) {
      delete data.header;
    }
    if (this.formFactory.addFace.length > 0 || this.formFactory.delFace.length > 0) {
       await this.shopService.albumShopFaceEdit(this.shopId, this.formFactory);
    }
    const res = await this.shopService.albumShopPhotoUpload(data);
    if (res) {
      this.$message.success('保存成功');
      // this.$emit('refResg');
      this.abandon();
    }
  }

  abandon() {
    this.$emit('refResg');
    this.formData = {};
    this.headerImg = [0, 0, 0, 0, 0];
    this.headerVideo = {};
    this.hasUnsavedChanges = true;
  }

  replace() {
    this.coverImagesModal.init();
  }

  selectFunFile(type: string) {
    // this.selectVideoModal.init();
    if (type === 'video') {
      if (this.headerVideo.is_template_photo != 1) {
        const id: any = this.returnDefaultData('video', 'id');
        this.selectVideoModal.init(id);
      }
    } else {
      this.selectImagesModal.init();
    }
  }

  oldHeaderId: any = [];

  uploadCover(val: any) {
    const type = 'cover';
    const data = {
      add: val,
    };
    const element = {
      element: val[0],
    };
    // this.defaultDate[type] = element;
    this.hasUnsavedChanges = true;
    this.$set(this.defaultDate, type, element);
    this.formData[type] = data;
  }

  init() {
    const { elements } = this.albumData.header || { elements: [] };
    this.oldHeaderId = elements.map((item: any) => item.resource_id);
    const { removed: headerVideo, remaining: headerImg } = this.removeByCategory(elements, 2);
    this.headerVideo = headerVideo[0] || {};
    this.headrtBList = headerImg.filter((item: any) => item.is_template_photo === 1);
    this.headerImg = [...headerImg.filter((item: any) => item.is_template_photo === 0), ...new Array(5 - headerImg.length).fill(0)];
    this.defaultDate = this.albumData;
    this.oldFaceId = this.albumData.face_photo || [];
    this.doorFaceImage = JSON.parse(JSON.stringify(this.oldFaceId));
    this.wordTitleArray = this.wordTitleArray.map((item: any) => {
      const { title, type: t } = item;
      const d = {
        title,
        type: t,
        id: this.returnDefaultData(t, 'id'),
      };
      return d;
    });
  }

  upLoadImage(val: any) {
    this.headerImg = val;
    this.hasUnsavedChanges = true;
  }

  upLoadVideo(val: any) {
    this.headerVideo = val[0];
    this.hasUnsavedChanges = true;
  }

  removeByCategory(arr: any[], categoryValue: number): {
    removed: any[];
    remaining: any[];
  } {
    const removed: any[] = [];
    const remaining: any[] = [];

    arr.forEach((item) => {
      if (item.category === categoryValue) {
        removed.push(item);
      } else {
        remaining.push(item);
      }
    });

    return { removed, remaining };
  }

  description() {
    this.qualityDescriptionModal.init();
  }

  changeSubmit(type: any, val: any) {
    // this.val = val;
    if (!Object.prototype.hasOwnProperty.call(this.defaultDate, type)) {
      const element = {
        cover: val.add[0].url,
      };
      this.$set(this.defaultDate, type, element);
    }
    this.hasUnsavedChanges = true;
    this.$set(this.formData, type, val);
  }


  returnDefaultData(type: any, enumeration: any) {
    // console.log(type, enumeration, Object.prototype.hasOwnProperty.call(this.albumData, type));
    if (Object.prototype.hasOwnProperty.call(this.defaultDate, type)) {
      if (Object.prototype.hasOwnProperty.call(this.defaultDate[type], enumeration)) {
        const text = this.defaultDate[type][enumeration];
        // console.log(text);
        return text;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  openVideo(name: string, type: string, albumId?: any) {
    const val: {
      edit: any;
      delete: any;
      add: any;
    } = this.formData[type] || {
      edit: [],
      delete: [],
      add: [],
    };

    const data = {
      edit: Object.prototype.hasOwnProperty.call(val, 'edit') ? val.edit : [],
      delete: Object.prototype.hasOwnProperty.call(val, 'delete') ? val.delete : [],
      add: Object.prototype.hasOwnProperty.call(val, 'add') ? val.add : [],
    };
    this.lookVideoModal.init(name, type, data, albumId);
  }


  openImage(name: string, type: string, albumId?: any) {
    const val: {
      edit: any;
      delete: any;
      add: any;
    } = this.formData[type] || {
      edit: [],
      delete: [],
      add: [],
    };

    const data = {
      edit: Object.prototype.hasOwnProperty.call(val, 'edit') ? val.edit : [],
      delete: Object.prototype.hasOwnProperty.call(val, 'delete') ? val.delete : [],
      add: Object.prototype.hasOwnProperty.call(val, 'add') ? val.add : [],
    };
    this.lookImagesModal.init(name, type, data, albumId);
  }
  playVideo(obj: any) {
    this.videoUModal.open(obj.path);
  }
}
